import * as R from 'ramda';
import React, { useEffect } from 'react';
// helpers/constants
import * as G from '../../../../helpers';
import * as GC from '../../../../constants';
// icons
import { AmousLogoAiComponent } from '../../../../svgs/amous-animated-logo/animated-logo';
// ui
import { Box, Flex } from '../../../../ui';
import { scrollableContainerCss4px } from '../../../../ui/common';
// feature fleet
import LeftTabs from './left-tabs';
import VendorForm from './vendor-form';
import ServiceForm from './service-form';
import InvoiceForm from './invoice-form';
import EstimatesTab from './estimates-tab';
//////////////////////////////////////////////////

const activeTabComponentMap = {
  0: ServiceForm,
  1: VendorForm,
  2: EstimatesTab,
};

const AiLoading = () => (
  <Flex alignItems='center' justifyContent='center'>
    <AmousLogoAiComponent />
  </Flex>
);

const LeftSection = (props) => {
  const {
    errors,
    values,
    invoiceGuid,
    leftActiveTab,
    setLeftActiveTab,
    aiRecognizeLoading,
  } = props;

  const Component = R.gt(leftActiveTab, 2) ? InvoiceForm : activeTabComponentMap[leftActiveTab];

  const { invoices } = values;

  const initialInvoices = R.path(['equipmentService', 'invoices'], props);

  useEffect(() => {
    if (R.and(G.isNotNil(invoiceGuid), G.isNotNilAndNotEmpty(initialInvoices))) {
      const invoiceIndex = R.findIndex(R.propEq(invoiceGuid, GC.FIELD_GUID), R.or(initialInvoices, []));

      setLeftActiveTab(R.add(R.length(R.keys(activeTabComponentMap)), invoiceIndex));
    }
  }, [invoiceGuid, initialInvoices]);

  return (
    <Box
      width={620}
      height='100%'
      flexShrink={0}
      overflow='auto'
      borderRight='1px solid'
      css={scrollableContainerCss4px}
      borderColor={G.getTheme('colors.lightGrey')}
    >
      <LeftTabs
        errors={errors}
        invoiceGuid={invoiceGuid}
        invoices={R.or(invoices, [])}
        leftActiveTab={leftActiveTab}
        setLeftActiveTab={setLeftActiveTab}
      />
      { G.isTrue(aiRecognizeLoading) && <AiLoading /> }
      { R.and(
        G.isFalse(aiRecognizeLoading),
        G.isNotNilAndNotEmpty(Component),
      ) && <Component {...props} />
      }
    </Box>
  );
};

export default LeftSection;
